export const renderValue = (curValue?: string) => curValue || '-';
